<template lang="html">
  <div class="shopify-create-store">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Create your store"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="closeLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyCreateStore',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'locate-sales-channels',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>In order to sell products and services on your website, you'll need to create a Shopify account and connect it to our platform.</p>

          <p>Shopify allows you can manage products, process orders and enter store data.</p>

          <p>The lowest Shopify plan (Lite) is required as <strong>our platform</strong> will be your shop's website. Shopify Lite costs $9/month after you have completed your 14 day trial.</p>

          <p><a class="btn is-tertiary" href="https://www.shopify.com/signup" target="_blank">Create a Shopify account</a> and then hit proceed.</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
